import React, { FC, useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { Timestamp } from "../../../firebase";

import { Modal } from "../../organisms/Modal";
import { theme } from "../../../config";
import { Comment } from "../../organisms/Comment";
import {
  BackIcon,
  Body,
  Header,
  HeaderText,
  LeftSideWrapper,
  RightSideWrapper,
  TabWrapper,
  Wrapper,
  CommentsWrapper,
  RecruitmentPhaseWrapper,
  RightDivsWrapper,
  FlexDiv,
  LoaderWrapper,
  DateWrapper,
  RecruitmentPhaseTag,
  StatusWrapper,
  RecruitmentHeader,
  StarIcon,
  SelectStyled,
  SaveInterviewersButton,
  ButtonWrapper,
  NoteStyled,
} from "./elements";
import { ApplicantDetailsTabs } from "../../organisms/ApplicantDetailsTabs";
import { Dropdown } from "../../atoms/Dropdown";
import { Menu, Select as AntSelect, Form, Tooltip, Row, Col } from "antd";
import { Alert } from "../../atoms/Alert";
import { Select } from "../../atoms/Select";
import { data, format } from "../../../constants";
import { Loader } from "../../atoms/Loader";
import { DatePicker } from "../../atoms/DatePicker";
import { ConfirmationModalBody } from "../../organisms/ConfirmationModalBody";
import back from "../../../assets/icons/back.svg";
import { setPhaseStatus } from "../../../utils/helpers/strings";
import { Comment as CommentType } from "../../../core/entities/comment";
import { star } from "../../../assets/icons/index";
import { DateConfirmationModalBody } from "../../organisms/DateConfirmationModalBody";
import { PermanentlyDeleteModalBody } from "../../organisms/PermanentlyDeleteModalBody";
import { Log } from "../../../core/entities/log";
import { CalendarEventLoader } from "../../organisms/CalendarEventLoader";
import { useMediaQuery } from "../../../hooks/common";
import { User } from "../../../core/entities/user";
import { InterviewerType } from "../../../core/entities/interviewer";
import { Documents } from "../../organisms/Documents";
import { ApplicantDocument } from "../../../core/entities/applicant";
import { OverlapScheduleConfirmationModalBody } from "../../organisms/OverlapScheduleConfirmationModalBody";
import { FailedApplicantModalBody } from "../../organisms/FailedApplicantModalBody";

const { Option } = AntSelect;

type Props = {
  onBack: () => void;
  onComment: () => void;
  comments: CommentType[];
  comment: string;
  onCommentChange: (
    e: any,
    newValue: any,
    newPlainTextValue: any,
    mentions: any
  ) => void;
  applicantDetails: any;
  openResume: () => void;
  downloadDocument: (fileUrl: string, customFileName?: string) => void;
  onModalConfirm: (applicationStatus: {
    currentStatus: string;
    finalInterview: boolean;
    initialInterview: boolean;
    jobOffer: boolean;
    newApplicant: boolean;
    psychological: boolean;
    shortlisted: boolean;
    subStatus: string;
  }) => void;
  // onChangeStatus: (value: string) => void;
  isLoading: boolean;
  isOverlap: boolean | null;
  isChecking: boolean;
  resetIsOverlap: () => void;
  checkSchedule: any;
  isLoadingFile: boolean;
  isUpdating: boolean;
  error: string;
  isUpdateSuccessful: boolean | null;
  onUpdateApplicantStatus?: (params: any) => void;
  resetIsUpdateSuccessful?: () => void;
  isCommentsLoading: boolean;
  accessType: string;
  fromSearch?: string;
  getLogs?: any;
  logs?: { id: string; logs: Log[] };
  interviewers?: any[];
  updateApplicantRequest?: any;
  searchUser?: (name: string) => void;
  user?: User;
  isSearchUsersLoading?: boolean;
  onUploadApplicantDocuments: (file: Blob | File, fileName: string) => void;
  isUploadApplicantDocumentsLoading: boolean;
  isUploadApplicantDocumentsSuccessful: boolean | null;
  deleteApplicantDocuments: (document: ApplicantDocument) => void;
  isDeleteApplicantDocumentsLoading: boolean;
  isDeleteApplicantDocumentsSuccessful: boolean | null;
};

const ApplicantDetails: FC<Props> = (props) => {
  const {
    onBack,
    onComment,
    comments,
    comment,
    onCommentChange,
    applicantDetails,
    openResume,
    downloadDocument,
    onModalConfirm,
    // onChangeStatus,
    isLoading,
    isOverlap,
    isChecking,
    resetIsOverlap,
    checkSchedule,
    isLoadingFile,
    isUpdating,
    error,
    isUpdateSuccessful,
    onUpdateApplicantStatus = () => {},
    resetIsUpdateSuccessful = () => {},
    isCommentsLoading,
    accessType,
    fromSearch,
    getLogs,
    logs,
    interviewers,
    updateApplicantRequest,
    searchUser,
    user,
    isSearchUsersLoading,
    onUploadApplicantDocuments,
    isUploadApplicantDocumentsLoading,
    isUploadApplicantDocumentsSuccessful,
    deleteApplicantDocuments,
    isDeleteApplicantDocumentsLoading,
    isDeleteApplicantDocumentsSuccessful,
  } = props;
  const MenuItem = Menu.Item;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [datePickerOpen, setDatePickerOpen] = useState<boolean>(false);
  const [isUpdatedSubStatus, setUpdatedSubStatus] = useState<boolean>(true);
  const [phaseKey, setPhaseKey] = useState("");
  const [failedReason, setFailed] = useState("");
  const [subStatus, setSubStatus] = useState("");
  const [isUpdateDate, setUpdateDate] = useState<boolean>(false);

  const [isToBeDeletedApplicantDocument, setIsToBeDeletedApplicantDocument] =
    useState<boolean>(false);
  const [applicantDocumentTobeDeleted, setApplicantDocumentTobeDeleted] =
    useState<ApplicantDocument | null>(null);

  const [customReason, setCustomReason] = useState<string>("");

  const [form] = Form.useForm();
  const history = useHistory();
  const navigationParams: { id: string } = useParams();
  const isMinimized = useMediaQuery(theme.breakpoints.minimized);
  const { id } = navigationParams;

  const startDatePickerRef = useRef<any>();
  const endDatePickerRef = useRef<any>();
  const timePickerRef = useRef<any>();
  const statusDropdownRef = useRef<any>();
  const interviewersRef = useRef<any>();

  const [isToBeDeclinedApplicant, setIsToBeDeclinedApplicant] =
    useState<boolean>(false);

  const onScrollPage = () => {
    if (startDatePickerRef.current) {
      startDatePickerRef.current.blur();
    }
    if (endDatePickerRef.current) {
      endDatePickerRef.current.blur();
    }
    if (timePickerRef.current) {
      timePickerRef.current.blur();
    }
    if (statusDropdownRef.current) {
      statusDropdownRef.current.blur();
    }
  };

  const handleOnCancelModal = () => {
    form.resetFields();
    setIsToBeDeclinedApplicant(false);
    setPhaseKey("");
    setSubStatus("");
    setShowModal(false);
  };

  const handleConfirmUpdateStatus = (status: string) => {
    const failedStatus = ["No Show", "No Response", "Blacklisted"];
    if (failedStatus.includes(status)) {
      onUpdateApplicantStatus({
        "applicationStatus.subStatus": status,
        "applicationStatus.currentStatus": "Failed",
        "applicationStatus.failedPhase":
          applicantDetails.applicationStatus.currentStatus,
        "applicationStatus.dateMoved": Timestamp.now(),
        "applicationStatus.dateFailed": Timestamp.now(),
      });
    } else if (status === "Declined") {
      onUpdateApplicantStatus({
        "applicationStatus.subStatus": status,
        "applicationStatus.failedPhase":
          applicantDetails.applicationStatus.currentStatus,
        "applicationStatus.dateMoved": Timestamp.now(),
      });
    } else if (status === "Failed") {
      onUpdateApplicantStatus({
        "applicationStatus.subStatus": "",
        "applicationStatus.currentStatus": status,
        "applicationStatus.failedReason": failedReason,
        "applicationStatus.failedPhase":
          applicantDetails.applicationStatus.currentStatus,
        "applicationStatus.dateMoved": Timestamp.now(),
        "applicationStatus.dateFailed": Timestamp.now(),
      });
    } else {
      onUpdateApplicantStatus({
        "applicationStatus.subStatus": status,
      });
    }
    setShowModal(false);
  };

  const [isDateConfirmationModal, setIsDateConfirmationModal] = useState(false);
  const [dateParams, setDateParams] = useState<any>(null);
  const handleDateReasonUpdate = async (params: any, isUpdateDate = true) => {
    if (
      currentStatus === "Job Offer" ||
      currentStatus === "Initial Interview" ||
      currentStatus === "Final Interview"
    ) {
      await getLogs(id);
      setIsDateConfirmationModal(true);
      setDateParams(params);
      return await checkSchedule(id, params?.[`scheduleDate.${phase}`], {
        interviewers: phase,
      });
    }
    startDatePickerRef.current.blur();
    if (isUpdateDate) {
      setUpdateDate(true);
    }
    setUpdatedSubStatus(true);
    onUpdateApplicantStatus(params);
  };

  useEffect(() => {
    const delayID = setTimeout(() => {
      if (isDateConfirmationModal) {
        if (isOverlap && !isChecking) {
          setShowModal(true);
        }
        if (isOverlap !== null && !isOverlap && !isChecking) {
          setShowModal(true);
        }
      }
    }, 100);
    return () => clearTimeout(delayID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOverlap, isChecking]);

  const onChangeStatus = (subStatus: string) => {
    switch (subStatus) {
      case "Declined":
        setSubStatus(subStatus);
        setUpdatedSubStatus(false);
        resetIsUpdateSuccessful();
        setIsToBeDeclinedApplicant(true);
        setShowModal(true);
        break;
      case "No Show":
      case "No Response":
      case "Blacklisted":
        setSubStatus(subStatus);
        setUpdatedSubStatus(false);
        resetIsUpdateSuccessful();
        setShowModal(true);
        break;
      case "Reschedule":
        setDatePickerOpen(true);
        setSubStatus(subStatus);
        break;
      case "Failed":
        setUpdatedSubStatus(false);
        resetIsUpdateSuccessful();
        setPhaseKey(subStatus);
        setShowModal(true);
        break;
      default:
        setUpdatedSubStatus(true);
        handleConfirmUpdateStatus(subStatus);
        break;
    }
  };

  const handleRescheduleStatus = (open: boolean) => {
    setDatePickerOpen(open);
  };

  const handleOnBlurDate = () => {
    setDatePickerOpen(false);
    form.resetFields();
  };

  const modalCancelBtn = () => {
    setShowModal(false);
  };

  const modalConfirmBtn = (key: string) => {
    setShowModal(false);
    let passedPhase: any;

    const applicationStatus = applicantDetails.applicationStatus;

    switch (applicationStatus.currentStatus) {
      case "Shortlisted":
        passedPhase = {
          shortlistedPassedDate: Timestamp.now(),
        };
        break;
      case "Techinical Exam":
        passedPhase = {
          technicalPassedDate: Timestamp.now(),
        };
        break;
      case "Initial Interview":
        passedPhase = {
          initialInterviewPassedDate: Timestamp.now(),
        };
        break;
      case "Psychological Exam":
        passedPhase = {
          psychologicalPassedDate: Timestamp.now(),
        };
        break;
      case "Final Interview":
        passedPhase = {
          finalInterviewPassedDate: Timestamp.now(),
        };
        break;
    }

    switch (key) {
      case "Read":
      case "Unread":
        onModalConfirm({ ...applicationStatus, subStatus: key });
        break;
      case "Shortlisted":
        onModalConfirm({
          ...applicationStatus,
          shortlisted: true,
          ...passedPhase,
          subStatus: "",
          currentStatus: key,
        });
        break;
      case "Technical Exam":
        onModalConfirm({
          ...applicationStatus,
          technical: true,
          ...passedPhase,
          subStatus: "",
          currentStatus: key,
        });
        break;
      case "Initial Interview":
        onModalConfirm({
          ...applicationStatus,
          initialInterview: true,
          ...passedPhase,
          subStatus: "",
          currentStatus: key,
        });
        break;
      case "Psychological Exam":
        onModalConfirm({
          ...applicationStatus,
          psychological: true,
          ...passedPhase,
          subStatus: "",
          currentStatus: key,
        });
        break;
      case "Final Interview":
        onModalConfirm({
          ...applicationStatus,
          finalInterview: true,
          ...passedPhase,
          subStatus: "",
          currentStatus: key,
        });
        break;
      case "Job Offer":
        onModalConfirm({
          ...applicationStatus,
          jobOffer: true,
          subStatus: "",
          currentStatus: key,
        });
        break;
      case "Failed":
        onModalConfirm({
          ...applicationStatus,
          subStatus: "",
          reason: failedReason,
          dateFailed: Timestamp.now(),
          currentStatus: key,
          failedPhase: applicationStatus.currentStatus,
        });
        break;
    }
  };

  const updateApplicantPhaseStatus = (key: string) => {
    setUpdatedSubStatus(false);
    resetIsUpdateSuccessful();
    setPhaseKey(key);
    setShowModal(true);
  };

  const failedSubStatusModalBody = (
    <ConfirmationModalBody
      applicantName={applicantDetails.fullName}
      fromStatus={subStatus}
      toStatusColor={theme.colors.utilities.error}
      toStatus="Failed"
      onConfirm={() => handleConfirmUpdateStatus(subStatus)}
      onCancel={handleOnCancelModal}
    />
  );

  const declinedSubStatusModalBody = (
    <ConfirmationModalBody
      applicantName={applicantDetails.fullName}
      fromStatus={
        applicantDetails.applicationStatus?.subStatus ||
        applicantDetails.applicationStatus?.currentStatus
      }
      toStatusColor={theme.colors.utilities.error}
      toStatus="Declined"
      onConfirm={() => handleConfirmUpdateStatus(subStatus)}
      onCancel={handleOnCancelModal}
    />
  );

  const [failedReasonsData, setfailedReasonsData] = useState<string[]>(
    data.failedReasons
  );
  const [isInitialsReasonSelected, setIsInitialsReasonSelected] = useState(true);
  const [otherReasonErrorMessage, setOtherReasonErrorMessage] = useState<string>("");

  const addOtherReason = (e: any, customReason: string) => {
    e.preventDefault();
    e.stopPropagation();
    if (customReason.trim() !== "" && customReason.trim().length <= 50) {
      setfailedReasonsData((prevItems) => [...prevItems, customReason]);
      setCustomReason("")
    }
    if (customReason.trim() === "") {
      setOtherReasonErrorMessage("Must not be empty");
    }
    if (customReason.trim().length >= 50) {
      setOtherReasonErrorMessage(
        "This field accepts 50 number of characters only."
      );
    }
  };

  const phaseUpdateModalBody = (
    <FailedApplicantModalBody
      applicantName={applicantDetails.fullName}
      subStatus={applicantDetails.applicationStatus?.subStatus}
      currentStatus={applicantDetails.applicationStatus?.currentStatus}
      phaseKey={phaseKey}
      isInitialsReasonSelected={isInitialsReasonSelected}
      handleSelectChange={(reason: string) => {
        setFailed(reason);
        setIsInitialsReasonSelected(
          failedReasonsData.slice(0, 5).includes(reason)
        );
      }}
      placeholder="Select"
      failedReasonsData={failedReasonsData}
      customReason={customReason}
      handleInputChange={(e: any) => {
        setCustomReason(e.target.value);
        e.target.value.length > 50
          ? setOtherReasonErrorMessage(
            "This field accepts 50 number of characters only."
          )
          : setOtherReasonErrorMessage("");
      }}
      handlePressEnter={(e: any) => addOtherReason(e, customReason)}
      otherReasonErrorMessage={otherReasonErrorMessage}
      failedReason={failedReason}
      onModalConfirm={() => modalConfirmBtn(phaseKey)}
      onModalCancel={modalCancelBtn}
    />
  );

  const [selectedInterviewers, setSelectedInterviewers] = useState<any>([]);
  const [disableSelectInterviewers, setDisableSelectInterviewers] =
    useState<boolean>(true);
  const [disableSaveButton, setDisableSaveButton] = useState<boolean>(true);

  let currentStatus = applicantDetails.applicationStatus?.currentStatus;
  const phase =
    currentStatus === "Initial Interview"
      ? "initialInterview"
      : currentStatus === "Final Interview"
      ? "finalInterview"
      : "jobOffer";

  const setDefaultInterviewers = () => {
    let newDefaultInterviewers: InterviewerType[] = [];
    const defaultInterviewers = defaultInterviewersFilter();
    defaultInterviewers?.forEach((i) => {
      interviewers?.some((interviewer) => {
        return (
          interviewer.name === i && newDefaultInterviewers.push(interviewer)
        );
      });
    });

    return [...newDefaultInterviewers];
  };

  const onConfirmDate = () => {
    const newInterviewers = {
      [phase]: {
        interviewers: [
          ...(applicantDetails?.interviewers &&
          applicantDetails?.interviewers[phase]
            ? [
                ...applicantDetails?.interviewers[phase].interviewers.map(
                  (interviewer: InterviewerType) => interviewer
                ),
              ]
            : [...setDefaultInterviewers()]),
        ],
        date: dateParams[Object.keys(dateParams)[0]],
      },
    };

    onUpdateApplicantStatus({
      ...dateParams,
      interviewers: newInterviewers,
      "applicationStatus.subStatus": subStatus,
    });
    onCancelDate();
  };

  const onCancelDate = () => {
    startDatePickerRef?.current.blur();
    resetIsOverlap();
    setShowModal(false);
    setIsDateConfirmationModal(false);
  };

  const onOverlapConfirmModal = () => {
    resetIsOverlap();
  };

  const updateInterviewers = (operation: string) => {
    setDisableSelectInterviewers(!disableSelectInterviewers);
    if (operation === "isSave") {
      let newSelectedInterviewers: InterviewerType[] = [];
      selectedInterviewers.map((interviewer: any) => {
        const found = interviewers?.find((el) => el.name === interviewer);
        return newSelectedInterviewers.push(found);
      });

      const interviewersParams = {
        [phase]: {
          interviewers: newSelectedInterviewers,
          ...(applicantDetails?.scheduleDate &&
            applicantDetails?.scheduleDate[phase] &&
            applicantDetails?.interviewers && {
              date: new Date(applicantDetails?.scheduleDate[phase].toDate()),
            }),
        },
      };
      const dateParams = {
        ...(applicantDetails?.scheduleDate &&
          applicantDetails?.scheduleDate[phase] &&
          applicantDetails?.interviewers && {
            [`scheduleDate.${phase}`]: new Date(
              applicantDetails?.scheduleDate[phase].toDate()
            ),
          }),
      };
      return onUpdateApplicantStatus({
        ...dateParams,
        ...(Object.getOwnPropertyNames(dateParams).length && {
          isUpdateInterviewers: true,
        }),
        interviewers: interviewersParams,
      });
    }
  };

  const setInterviewers = () => {
    let interviewers: string[] = ["hrph@vananaz.com"];
    if (
      applicantDetails?.interviewers &&
      applicantDetails.interviewers[phase]
    ) {
      applicantDetails.interviewers[phase]?.interviewers.map(
        (interviewer: InterviewerType) => interviewers.push(interviewer.name)
      );
    } else {
      interviewers = [
        ...interviewers,
        ...data.defaultInterviewers.map((interviewer) => interviewer.name),
      ];
    }
    return interviewers;
  };

  const dateConfirmationModalBody = (
    <DateConfirmationModalBody
      date={dateParams?.[`scheduleDate.${phase}`] as any}
      phase={currentStatus}
      onConfirm={onConfirmDate}
      onCancel={onCancelDate}
      logs={logs}
      interviewers={setInterviewers()}
    />
  );

  const overlapDateConfirmationModalBody = (
    <OverlapScheduleConfirmationModalBody
      onConfirm={onOverlapConfirmModal}
      onCancel={onCancelDate}
    />
  );

  const moveToMenus = (
    //put algorithm to disable an item if it is already in that phase
    <Menu onClick={({ key }) => updateApplicantPhaseStatus(key)}>
      <MenuItem
        style={{ paddingRight: "100px" }}
        key="Unread"
        disabled={
          applicantDetails.applicationStatus &&
          (applicantDetails.applicationStatus.subStatus === "Unread" ||
            applicantDetails.applicationStatus.currentStatus !==
              "New Applicant")
        }
      >
        Unread
      </MenuItem>
      <MenuItem
        key="Read"
        disabled={
          applicantDetails.applicationStatus &&
          (applicantDetails.applicationStatus.subStatus === "Read" ||
            applicantDetails.applicationStatus.currentStatus !==
              "New Applicant")
        }
      >
        Read
      </MenuItem>
      <MenuItem
        key="Shortlisted"
        disabled={
          applicantDetails.applicationStatus &&
          !!applicantDetails.applicationStatus.shortlisted
        }
      >
        Shortlisted
      </MenuItem>
      <MenuItem
        key="Technical Exam"
        disabled={
          applicantDetails.applicationStatus &&
          !!applicantDetails.applicationStatus.technical
        }
      >
        Technical Exam
      </MenuItem>
      <MenuItem
        key="Initial Interview"
        disabled={
          applicantDetails.applicationStatus &&
          !!applicantDetails.applicationStatus.initialInterview
        }
      >
        Initial Interview
      </MenuItem>
      <MenuItem
        key="Psychological Exam"
        disabled={
          applicantDetails.applicationStatus &&
          !!applicantDetails.applicationStatus.psychological
        }
      >
        Psychological Exam
      </MenuItem>
      <MenuItem
        key="Final Interview"
        disabled={
          applicantDetails.applicationStatus &&
          !!applicantDetails.applicationStatus.finalInterview
        }
      >
        Final Interview
      </MenuItem>
      <MenuItem
        key="Job Offer"
        disabled={
          applicantDetails.applicationStatus &&
          !!applicantDetails.applicationStatus.jobOffer
        }
      >
        Job Offer
      </MenuItem>
      <MenuItem
        key="Failed"
        style={{
          display:
            applicantDetails.applicationStatus?.currentStatus ===
            "New Applicant"
              ? "block"
              : "none",
        }}
        disabled={
          applicantDetails.applicationStatus?.currentStatus !== "New Applicant"
        }
      >
        Failed
      </MenuItem>
    </Menu>
  );

  useEffect(() => {
    if (
      !isUpdatedSubStatus &&
      isUpdateSuccessful &&
      applicantDetails.applicationStatus &&
      applicantDetails.applicationStatus?.currentStatus &&
      applicantDetails.applicationStatus?.currentStatus !== "New Applicant"
    ) {
      setTimeout(() => {
        history.replace(
          `/recruit/${setPhaseStatus(
            applicantDetails.applicationStatus.currentStatus
          )}`,
          {
            applicantId: id,
            fromSearch: fromSearch === "true" ? fromSearch : undefined,
          }
        );
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isUpdatedSubStatus, isUpdateSuccessful, applicantDetails]);

  useEffect(() => {
    return () => {
      window.history.replaceState({}, "");
    };
  }, []);

  useEffect(() => {
    setDisableSaveButton(true);
    if (!isLoading && !isUpdating) {
      setUpdateDate(false);
    }
  }, [isLoading, isUpdating]);

  useEffect(() => {
    if (applicantDetails?.interviewers) {
      let applicantsInterviewers: any[] = [];

      const key = currentStatus && phase;
      applicantDetails?.interviewers[key] &&
        applicantDetails?.interviewers[key].interviewers.map(
          (interviewer: any) => applicantsInterviewers.push(interviewer.name)
        );
      return setSelectedInterviewers([...applicantsInterviewers]);
    }
    return setSelectedInterviewers([...defaultInterviewersFilter()]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantDetails, interviewers]);

  const defaultInterviewersFilter = () => {
    let filteredInterviewers: string[] = [];
    data.defaultInterviewers.forEach((i) => {
      if (interviewers && interviewers.length) {
        interviewers.filter((e: any) => e.email === i.email).length &&
          filteredInterviewers.push(i.name);
      }
    });
    return filteredInterviewers;
  };

  const onChangeInterviewers = (value: string[]) => {
    if (
      applicantDetails?.interviewers &&
      applicantDetails.interviewers[phase]
    ) {
      const applicantInterviewers = [
        ...applicantDetails.interviewers[phase].interviewers.map(
          (i: InterviewerType) => i.name
        ),
      ];
      setDisableSaveButton(
        [...value].toString() === applicantInterviewers.toString()
      );
    }
    return setSelectedInterviewers([...value]);
  };

  const handleShowDeleteDocumentModal = (document: ApplicantDocument) => {
    setIsToBeDeletedApplicantDocument(true);
    setApplicantDocumentTobeDeleted(document);
    setShowModal(true);
  };

  const handleCancelDeleteApplicantDocument = () => {
    setIsToBeDeletedApplicantDocument(false);
    setApplicantDocumentTobeDeleted(null);
    setShowModal(false);
  }

  const handleConfirmDeleteApplicantDocument = () => {
    deleteApplicantDocuments(applicantDocumentTobeDeleted as ApplicantDocument);
  };

  useEffect(() => {
    if (!isDeleteApplicantDocumentsLoading && isDeleteApplicantDocumentsSuccessful !== null) {
      setShowModal(false);
      setIsToBeDeletedApplicantDocument(false);
      setApplicantDocumentTobeDeleted(null);
    }
  }, [isDeleteApplicantDocumentsLoading, isDeleteApplicantDocumentsSuccessful])

  const permanentlyDeleteModalBody =  (
    <PermanentlyDeleteModalBody 
      onConfirm={handleConfirmDeleteApplicantDocument} 
      onCancel={handleCancelDeleteApplicantDocument} 
      isLoading={isDeleteApplicantDocumentsLoading}
    />
  );

  return (
    <>
      <Wrapper onScroll={onScrollPage}>
        {!isUpdateDate &&
        (isLoading ||
          isUpdating ||
          isChecking ||
          !applicantDetails["positionApplied"]) ? (
          <LoaderWrapper>
            {(isChecking ||
              (updateApplicantRequest?.request &&
                updateApplicantRequest?.request.data?.interviewers &&
                Object.getOwnPropertyNames(
                  updateApplicantRequest?.request?.data
                ).length > 1)) && (
              <CalendarEventLoader
                isChecking={isChecking}
                isUpdateInterviewers={updateApplicantRequest?.request?.data.hasOwnProperty(
                  "isUpdateInterviewers"
                )}
              />
            )}
            <Loader />
          </LoaderWrapper>
        ) : (
          <>
            <Header>
              <LeftSideWrapper>
                <BackIcon src={back} onClick={onBack} />
                <div>
                  <HeaderText>
                    {applicantDetails.fullName}{" "}
                    {applicantDetails.referredBy && <StarIcon src={star} />}
                  </HeaderText>
                </div>
              </LeftSideWrapper>
              <RightSideWrapper>
                {applicantDetails.applicationStatus &&
                  applicantDetails.applicationStatus.currentStatus !==
                    "Job Offer" &&
                  applicantDetails.applicationStatus.currentStatus !==
                    "Failed" &&
                  accessType !== "interviewer" && (
                    <Dropdown menu={moveToMenus} type="primary">
                      Move to
                    </Dropdown>
                  )}
              </RightSideWrapper>
            </Header>
            <Body>
              <TabWrapper>
                <ApplicantDetailsTabs
                  isInterviewer={accessType === "interviewer"}
                  applicantDetails={applicantDetails}
                  openResume={openResume}
                  isDownloadingResume={isLoadingFile}
                  downloadDocument={downloadDocument}
                />
              </TabWrapper>
              <RightDivsWrapper>
                {applicantDetails &&
                  applicantDetails.applicationStatus &&
                  (!applicantDetails.applicationStatus.newApplicant ||
                    applicantDetails.applicationStatus.currentStatus !==
                      "New Applicant") && (
                    <RecruitmentPhaseWrapper>
                      <FlexDiv>
                        <RecruitmentHeader>Recruitment Phase</RecruitmentHeader>
                        <div>
                          <RecruitmentPhaseTag
                            color={
                              applicantDetails.applicationStatus
                                .currentStatus === "Failed"
                                ? theme.colors.red
                                : theme.colors.custom.darkblue1
                            }
                            $isFailed={
                              applicantDetails.applicationStatus
                                .currentStatus === "Failed"
                            }
                          >
                            {applicantDetails.applicationStatus.currentStatus}
                          </RecruitmentPhaseTag>
                        </div>
                      </FlexDiv>
                      <StatusWrapper>
                        <span>Status</span>
                        <Form form={form}>
                          <Form.Item shouldUpdate name="status">
                            <Select
                              disabled={accessType === "interviewer"}
                              placeholder={"Select"}
                              optionItems={
                                <>
                                  {applicantDetails.applicationStatus
                                    .currentStatus === "Job Offer" &&
                                  applicantDetails.applicationStatus.jobOffer
                                    ? ( data.jobOfferStatuses.map(
                                        (status: string) => (
                                          <Option key={status} value={status}>
                                            {status}
                                          </Option>
                                        )
                                      )
                                    ) : applicantDetails.applicationStatus
                                      .currentStatus === "Failed" ? (
                                        applicantDetails.applicationStatus
                                        .subStatus ? (
                                        <Option
                                          key={
                                            applicantDetails.applicationStatus
                                              .subStatus
                                          }
                                          value={
                                            applicantDetails.applicationStatus
                                              .subStatus
                                          }
                                          disabled
                                        >
                                          {
                                            applicantDetails.applicationStatus
                                              .subStatus
                                          }
                                        </Option>
                                      ) : (
                                        <Option
                                          key="Failed"
                                          value="Failed"
                                          disabled
                                        >
                                          Failed
                                        </Option>
                                      )
                                  ) : (
                                    data.applicationStatus.map(
                                      (status: string) => (
                                        <Option key={status} value={status}>
                                          {status}
                                        </Option>
                                      )
                                    )
                                  )}
                                </>
                              }
                              defaultValue={
                                !applicantDetails.applicationStatus.subStatus &&
                                applicantDetails.applicationStatus
                                  .currentStatus === "Failed"
                                  ? "Failed"
                                  : applicantDetails.applicationStatus
                                      .subStatus === "Unassigned"
                                  ? ""
                                  : applicantDetails.applicationStatus.subStatus
                              }
                              width={"151px"}
                              handleChange={onChangeStatus}
                              ref={statusDropdownRef}
                            ></Select>
                          </Form.Item>
                        </Form>
                      </StatusWrapper>
                      {applicantDetails.applicationStatus.initialInterview &&
                        applicantDetails.applicationStatus.currentStatus ===
                          "Initial Interview" && (
                          <DateWrapper>
                            <p>Interview Date</p>
                            <DatePicker
                              showTime
                              formatProp={"MM/DD/YYYY  hh:mm A"}
                              disabled={accessType === "interviewer"}
                              onOk={() => startDatePickerRef.current.blur()}
                              value={
                                applicantDetails?.scheduleDate?.initialInterview
                                  ? moment(
                                      applicantDetails?.scheduleDate?.initialInterview.toDate(),
                                      format.dateTimeFormat
                                    )
                                  : undefined
                              }
                              open={datePickerOpen}
                              onOpenChange={(open) =>
                                handleRescheduleStatus(open)
                              }
                              onBlur={handleOnBlurDate}
                              onChange={(date: any) => {
                                handleDateReasonUpdate({
                                  "scheduleDate.initialInterview": new Date(
                                    date
                                  ),
                                });
                              }}
                              disabledDate={() => false}
                              ref={startDatePickerRef}
                              placeholder={"Date and Time"}
                            />
                          </DateWrapper>
                        )}
                      {applicantDetails.applicationStatus.technical &&
                        applicantDetails.applicationStatus.currentStatus ===
                          "Technical Exam" && (
                          <DateWrapper>
                            <p>Test Date</p>
                            <div style={{ display: "flex", columnGap: "10px" }}>
                              <div style={{ width: "100%" }}>
                                <DatePicker
                                  placeholder="Start Date"
                                  onChange={(date: any) => {
                                    handleDateReasonUpdate({
                                      "scheduleDate.technicalExam.startDate":
                                        new Date(date),
                                    });
                                  }}
                                  disabledDate={(current) => {
                                    if (
                                      applicantDetails?.scheduleDate
                                        ?.technicalExam?.endDate
                                    ) {
                                      return (
                                        moment(
                                          applicantDetails?.scheduleDate?.technicalExam?.endDate.toDate()
                                        )
                                          .format("MM/DD/YYY")
                                          .valueOf() <
                                        current.format("MM/DD/YYY").valueOf()
                                      );
                                    }
                                    return false;
                                  }}
                                  value={
                                    applicantDetails?.scheduleDate
                                      ?.technicalExam?.startDate
                                      ? moment(
                                          applicantDetails?.scheduleDate?.technicalExam?.startDate.toDate(),
                                          format.dateTimeFormat
                                        )
                                      : undefined
                                  }
                                  ref={startDatePickerRef}
                                />
                              </div>
                              <div style={{ width: "100%" }}>
                                <DatePicker
                                  disabled={
                                    !applicantDetails?.scheduleDate
                                      ?.technicalExam?.startDate
                                  }
                                  placeholder="End Date"
                                  onChange={(date: any) => {
                                    handleDateReasonUpdate({
                                      "scheduleDate.technicalExam.endDate":
                                        new Date(date),
                                    });
                                  }}
                                  disabledDate={(current) => {
                                    return (
                                      moment(
                                        applicantDetails?.scheduleDate?.technicalExam?.startDate.toDate()
                                      )
                                        .format("MM/DD/YYY")
                                        .valueOf() >
                                      current.format("MM/DD/YYY").valueOf()
                                    );
                                  }}
                                  value={
                                    applicantDetails?.scheduleDate
                                      ?.technicalExam?.endDate
                                      ? moment(
                                          applicantDetails?.scheduleDate?.technicalExam?.endDate.toDate(),
                                          format.dateTimeFormat
                                        )
                                      : undefined
                                  }
                                  ref={endDatePickerRef}
                                />
                              </div>
                            </div>
                          </DateWrapper>
                        )}
                      {applicantDetails.applicationStatus.psychological &&
                        applicantDetails.applicationStatus.currentStatus ===
                          "Psychological Exam" && (
                          <DateWrapper>
                            <p>Test Date</p>
                            <DatePicker
                              value={
                                applicantDetails?.scheduleDate
                                  ?.psychologicalExam
                                  ? moment(
                                      applicantDetails?.scheduleDate?.psychologicalExam.toDate(),
                                      format.dateTimeFormat
                                    )
                                  : undefined
                              }
                              onChange={(date: any) => {
                                handleDateReasonUpdate({
                                  "scheduleDate.psychologicalExam": new Date(
                                    date
                                  ),
                                });
                              }}
                              disabledDate={() => false}
                              ref={startDatePickerRef}
                            />
                          </DateWrapper>
                        )}
                      {applicantDetails.applicationStatus.finalInterview &&
                        applicantDetails.applicationStatus.currentStatus ===
                          "Final Interview" && (
                          <DateWrapper>
                            <p>Interview Date</p>
                            <DatePicker
                              showTime
                              formatProp={"MM/DD/YYYY  hh:mm A"}
                              disabled={accessType === "interviewer"}
                              onOk={() => startDatePickerRef.current.blur()}
                              value={
                                applicantDetails?.scheduleDate
                                  ?.finalInterview &&
                                applicantDetails?.interviewers
                                  ? moment(
                                      applicantDetails?.scheduleDate?.finalInterview.toDate(),
                                      format.dateTimeFormat
                                    )
                                  : undefined
                              }
                              onChange={(date: any) => {
                                handleDateReasonUpdate({
                                  "scheduleDate.finalInterview": new Date(date),
                                });
                              }}
                              open={datePickerOpen}
                              onOpenChange={(open) =>
                                handleRescheduleStatus(open)
                              }
                              onBlur={handleOnBlurDate}
                              disabledDate={() => false}
                              ref={startDatePickerRef}
                              placeholder={"Date and Time"}
                            />
                          </DateWrapper>
                        )}
                      {applicantDetails.applicationStatus.jobOffer &&
                        applicantDetails.applicationStatus.currentStatus ===
                          "Job Offer" && (
                          <DateWrapper>
                            <p>Interview Date</p>
                            <DatePicker
                              showTime
                              formatProp={"MM/DD/YYYY  hh:mm A"}
                              onOk={() => startDatePickerRef.current.blur()}
                              value={
                                applicantDetails?.scheduleDate?.jobOffer &&
                                applicantDetails?.interviewers
                                  ? moment(
                                      applicantDetails?.scheduleDate?.jobOffer.toDate(),
                                      format.dateTimeFormat
                                    )
                                  : undefined
                              }
                              open={datePickerOpen}
                              onOpenChange={(open) =>
                                handleRescheduleStatus(open)
                              }
                              onBlur={handleOnBlurDate}
                              onChange={(date: any) => {
                                handleDateReasonUpdate({
                                  "scheduleDate.jobOffer": new Date(date),
                                });
                              }}
                              disabledDate={() => false}
                              ref={startDatePickerRef}
                              placeholder={"Date and Time"}
                            />
                          </DateWrapper>
                        )}
                      {applicantDetails.applicationStatus.currentStatus ===
                        "Failed" && (
                        <StatusWrapper>
                          <span>Reason</span>
                          <Form form={form}>
                            <Form.Item shouldUpdate name="reason">
                              <Select
                                dropdownStyle={{ width: 300 }}
                                placeholder={"Reason"}
                                handleChange={(reason: string) => {
                                  handleDateReasonUpdate(
                                    {
                                      "applicationStatus.reason": reason,
                                    },
                                    false
                                  );
                                }}
                                optionItems={
                                  <>
                                    {data.failedReasons.map(
                                      (status: string) => (
                                        <Option key={status} value={status}>
                                          {status}
                                        </Option>
                                      )
                                    )}
                                    {!data.failedReasons.includes(
                                      applicantDetails.applicationStatus.reason
                                    ) && (
                                      <Option
                                        style={{ wordWrap: "break-word" }}
                                        key={
                                          applicantDetails.applicationStatus
                                            .reason
                                        }
                                        value={
                                          applicantDetails.applicationStatus
                                            .reason
                                        }
                                      >
                                        {
                                          applicantDetails.applicationStatus
                                            .reason
                                        }
                                      </Option>
                                    )}
                                  </>
                                }
                                defaultValue={
                                  applicantDetails.applicationStatus.reason
                                }
                                width={"151px"}
                                ref={statusDropdownRef}
                              ></Select>
                            </Form.Item>
                          </Form>
                        </StatusWrapper>
                      )}
                      {(applicantDetails.applicationStatus.currentStatus ===
                        "Initial Interview" ||
                        applicantDetails.applicationStatus.currentStatus ===
                          "Final Interview" ||
                        applicantDetails.applicationStatus.currentStatus ===
                          "Job Offer") && (
                        <Row gutter={[8, 8]}>
                          <Col xxl={20} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <div style={{ width: "100%" }}>
                              <span>Interviewer</span>
                              <br />
                              <NoteStyled>
                                <i>
                                  Note: <b>hrph@vananaz.com</b> is the default
                                  interviewer.
                                </i>
                              </NoteStyled>
                              <SelectStyled
                                mode={"multiple" as const}
                                style={{ width: "100%" }}
                                ref={interviewersRef}
                                placeholder="Search Interviewer"
                                onChange={(value: any) =>
                                  onChangeInterviewers(value)
                                }
                                maxTagCount={
                                  isMinimized ? 1 : ("responsive" as const)
                                }
                                showArrow={true}
                                value={[...selectedInterviewers]}
                                disabled={disableSelectInterviewers}
                                maxTagPlaceholder={(omittedValues) => (
                                  <Tooltip
                                    title={omittedValues.map((v, key) => (
                                      <div
                                        key={key}
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: 400,
                                        }}
                                      >
                                        {v.value}
                                      </div>
                                    ))}
                                    placement="bottom"
                                  >
                                    {`+ ${omittedValues.length}`}
                                  </Tooltip>
                                )}
                              >
                                {interviewers &&
                                  interviewers.map((interviewer, key) => {
                                    return (
                                      <Option
                                        key={key}
                                        value={interviewer.name}
                                      >
                                        {interviewer.name}
                                      </Option>
                                    );
                                  })}
                              </SelectStyled>
                            </div>
                          </Col>
                          <ButtonWrapper
                            xxl={4}
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                          >
                            <div style={{ width: "100%" }}>
                              <SaveInterviewersButton
                                onClick={() =>
                                  updateInterviewers(
                                    disableSelectInterviewers
                                      ? "isEdit"
                                      : "isSave"
                                  )
                                }
                                type={"default"}
                                disabled={
                                  applicantDetails?.interviewers &&
                                  applicantDetails?.interviewers[phase] &&
                                  !disableSelectInterviewers &&
                                  disableSaveButton
                                }
                              >
                                {disableSelectInterviewers ? "Edit" : "Save"}
                              </SaveInterviewersButton>
                            </div>
                          </ButtonWrapper>
                        </Row>
                      )}
                    </RecruitmentPhaseWrapper>
                  )}
                <CommentsWrapper>
                  <Documents 
                    documents={applicantDetails.documents} 
                    resume={applicantDetails.resume} 
                    onShowDeleteModal={handleShowDeleteDocumentModal}
                    onDownloadDocument={downloadDocument}
                  />
                  <Comment
                    onComment={onComment}
                    comments={comments}
                    value={comment}
                    onChange={onCommentChange}
                    isCommentsLoading={isCommentsLoading}
                    searchUser={searchUser}
                    isUsersLoading={isSearchUsersLoading}
                    onUploadApplicantDocuments={onUploadApplicantDocuments}
                    isUploadApplicantDocumentsLoading={isUploadApplicantDocumentsLoading}
                  />
                </CommentsWrapper>
              </RightDivsWrapper>
            </Body>
            {isUpdateSuccessful !== null &&
              !isUpdatedSubStatus &&
              isUpdateSuccessful && (
                <Alert
                  type="success"
                  message={
                    applicantDetails.applicationStatus.currentStatus ===
                    "Failed"
                      ? "Applicant moved to failed status"
                      : "Successfully moved applicant’s status"
                  }
                  showIcon
                />
              )}
            {
              isUploadApplicantDocumentsSuccessful && (
                <Alert
                  type="success"
                  message="File attachment successful"
                  showIcon
                />
              )
            }
            {
              isDeleteApplicantDocumentsSuccessful && (
                <Alert
                  type="success"
                  message="File sucessfully deleted"
                  showIcon
                />
              )
            }
            {error && <Alert type="error" message={error} showIcon />}
          </>
        )}
      </Wrapper>
      {isDateConfirmationModal && isChecking ? (
        ""
      ) : (
        <Modal
          visible={showModal}
          onModalClose={
            isToBeDeletedApplicantDocument 
              ? handleCancelDeleteApplicantDocument 
              : isDateConfirmationModal 
                ? onCancelDate 
                : handleOnCancelModal
          }
          title={
            isToBeDeletedApplicantDocument
              ? "Permanently Delete"
              : isDateConfirmationModal
                ? isOverlap
                  ? "Schedule Conflict"
                  : "Date Confirmation"
                : "Confirmation to move applicant status"
          }
          body={
            isToBeDeletedApplicantDocument 
              ? permanentlyDeleteModalBody
              : isDateConfirmationModal
              ? isOverlap
                ? overlapDateConfirmationModalBody
                : dateConfirmationModalBody
                : isToBeDeclinedApplicant
                ? declinedSubStatusModalBody
                : !subStatus
                ? phaseUpdateModalBody
                : failedSubStatusModalBody
          }
        />
      )}
    </>
  );
};

export default ApplicantDetails;
